import {Component, Input} from '@angular/core';
import {FormGroup} from "@angular/forms";

@Component({
  selector: 'form-field-image',
  templateUrl: 'form-field-image.component.html',
  styleUrls: ['form-field-image.component.scss']
})
export class FormFieldImageComponent {
  @Input() field!: any;
  @Input() formGroup!: FormGroup;

  constructor() {
  }

  ngOnInit() {
  }
}
